import { Axios } from './axios'


export function SGetRank(date) {
    return Axios({
        url: `leaderboards?date=${date}`,
        method: 'get',
    })
}


export function SGetAwards(params) {
    return Axios({
        url: `box/detail?id=${params}`,
        method: 'get',
    })
}


export function SOpenBox(id, num) {
    return Axios({
        url: `open`,
        method: 'post',
        data: {
            id,
            num
        }
    })
}

export function SGetLucky(params) {
    return Axios({
        url: `award/get?id=${params}`,
        method: 'get',
    })
}


export function SLuckyOpen(id, percent) {
    return Axios({
        url: `lucky/open`,
        method: 'post',
        data: {
            id,
            percent
        }
    })
}


export function SToBean(params) {
    return Axios({
        url: `cash`,
        method: 'post',
        data: {
            data: JSON.stringify(params)
        }
    })
}


export function SToSteam(params) {
    return Axios({
        url: `extract`,
        method: 'post',
        data: {
            data: JSON.stringify(params)
        }
    })
}


export function GetMy() {
    return Axios({
        url: `me`,
        method: 'get'
    })
}


export function SGetRoll(page) {
    return Axios({
        url: `rooms?page=${page}`,
        method: 'get'
    })
}


export function SMyRoll(page) {
    return Axios({
        url: `user/rooms?page=${page}`,
        method: 'get'
    })
}


export function SRollInfo(id) {
    return Axios({
        url: `room/detail?id=${id}`,
        method: 'get'
    })
}


export function SJoinHome(...params) {
    return Axios({
        url: `room/join`,
        method: 'post',
        data: {
            id: params[0],
            password: params[1],
        }
    })
}


export function SStorage(...params) {
    return Axios({
        url: `storage?page=${params[0] || 0}`,
        method: 'get',
        data: {
            page: params[0] || 0,
            status: params[1] || 0,
        }
    })
}

